import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthQuery } from '@ascschool/core/auth';
import { MailService } from '@ascschool/services/mail/mail.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { SelectTreeComponent } from '../select-tree/select-tree.component';
@Component({
  selector: 'app-pop-up-compose',
  templateUrl: './pop-up-compose.component.html',
  styleUrls: ['./pop-up-compose.component.scss']
})
export class PopUpComposeComponent implements OnInit {
  @ViewChildren("label") labelElement: any;
  @Input('mode') mode: 'new' | 'reply' | 'reply-all' | 'forward' = 'new';
  @Input('id') id: number;
  @Input() data: any;
  @Input() filesRes: any = [];
  @Input() type: any;
  ckeConfig: any;
  validateForm: FormGroup;
  listTo = [];
  listCC = [];
  lstAllUser = [];
  uid: number;
  lstAttach = [];
  lstAttachnz = [];
  lstAttachSaved = [];
  files: any[] = [];
  fileList: NzUploadFile[] = [];
  constructor(
    private modal: NzModalRef,
    private service: MailService,
    private fb: FormBuilder,
    private authQuery: AuthQuery,
    private msg: NzMessageService,
    private modalService: NzModalService,
    public utilsService: UtilsService,
  ) {
    this.validateForm = this.fb.group({
      id: this.fb.control(0),
      sender: this.fb.control(''),
      subject: this.fb.control('', Validators.required),
      body: this.fb.control(''),
      listTo: this.fb.control([], Validators.required),
      listCc: this.fb.control([]),
      listAttachment: this.fb.control(''),
      bodyReply: this.fb.control(''),
    });
  }
  ngOnInit() {
    this.loadUserId();
    this.loadAllUser();
    this.loadFileAttacment();
    this.ckeConfig = {
      allowedContent: false,
      extraPlugins: 'divarea',
      forcePasteAsPlainText: true
    };
  }
  close(e: MouseEvent) {
    e.preventDefault();
      this.modal.destroy(true);
  }
  submit(){
    this.validateForm.controls.listAttachment.setValue(this.lstAttach);
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }
  hanlderSendMail() {
    this.submit();
    if(this.validateForm.valid){
      this.service.send(this.validateForm.value).subscribe(
        (response: any) => {
          this.msg.success('Gửi thành email công');
          this.modal.destroy(true);
        },
        (error) => {
          this.msg.error('Gửi email thất bại vui lòng thử lại');
        });
    }else{
      this.utilsService.showNotifyInvalidControls(this.validateForm,this.labelElement);
    }
  }
  hanlderSaveMail() {
    this.submit();
    if(this.validateForm.valid){
      this.service.save(this.validateForm.value).subscribe(
        (response: any) => {
          this.msg.success('Lưu thành email công');
          this.modal.destroy(true);
        },
        (error) => {
          this.msg.error('Lưu email thất bại vui lòng thử lại');
        });
    }else{
      this.utilsService.showNotifyInvalidControls(this.validateForm,this.labelElement);
    }
  }

  loadAllUser() {
    this.service.getListUser().subscribe(
      (res) => {
        const indexUser = res.findIndex(x => x.id == this.uid);
        res.splice(indexUser, 1);
        this.listTo = res;
        this.listCC = res; 
        if (this.id > 0) {
          if (this.mode == 'new') {
            this.loadData();
          } else {
            this.loadDataReply(this.mode);
          }
        }
      }
    );
  }
  loadUserId(){
    this.authQuery.userToken$.subscribe(res =>{
      const obj = new JwtHelperService().decodeToken(res);
      this.uid = obj.uid;
      this.validateForm.controls.sender.setValue(this.uid);
    });
  }
  private _chatSubscription;
  loadFileAttacment(){
    this.service.done.subscribe((lstId: any) => {
      if (lstId) {
        lstId.map(x => {
          this.lstAttach.push(x.id);
          this.lstAttachSaved.push(x);
        });
      }
    });
  }
  ngOnDestroy(){
    this.service.done.next(null);
  }
  hanldeRemove = (file: any) => new Observable<boolean>((obs) => {
    const indexUser = this.fileList.findIndex(x => x.uid == file.uid);
    const fileId = this.lstAttach[indexUser];
    const findIdOldFile = this.filesRes.findIndex(x => x.uid == fileId);
    if (findIdOldFile > -1) {
      this.service.deleteFile(fileId).subscribe(
        () => {
          this.lstAttach.splice(indexUser, 1);
          this.lstAttachSaved.splice(indexUser, 1);
          this.files.splice(indexUser, 1);
          obs.next(true);
        }
      );
    }else{ 
      this.lstAttach.splice(indexUser, 1);
      this.lstAttachSaved.splice(indexUser, 1);
      this.files.splice(indexUser, 1);
      obs.next(true);
    }
  });
  deleteAllFile(){
    this.lstAttach.forEach((element)=>{
      this.service.deleteFile(element).subscribe(
        () => {
          console.log('Xóa thành công!');
        }
      );
    });
    this.modal.destroy(true);
  }
  //file
  beforeUpload = (file: NzUploadFile): boolean => {
    let files: NzUploadFile[] = [];
    files.push(file);
    this.fileList = this.fileList.concat(file);
    this.prepareFilesList(files);
    return false;
  };

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 100;
      this.files.push(item);
      this.service.addFileToQueue(item);
    }
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  loadData() {
    if (this.id > 0) {
      this.service.getComposeDetail(this.id).subscribe(
        (object) => {
          this.validateForm.controls.subject.setValue(object.subject);
          this.validateForm.controls.body.setValue(object.body);
          this.validateForm.controls.listTo.setValue(object.listTo);
          this.validateForm.controls.listCc.setValue(object.listCc);
        }
      );
      this.service.getListFiles(this.id).subscribe((res)=>{
        this.fileList = res.result.map(x => ({
          uid : x.id,
          name : x.fileName,
          status : 'done'
        }));
      });
    }
  }
  loadDataReply(mode: 'reply' | 'reply-all' | 'forward') {
    let prefix = '';
    switch (this.mode) {
      case 'reply':
        prefix = 'RE: ';
        break;
      case 'reply-all':
        prefix = 'RE: ';
        break;
      case 'forward':
        prefix = 'FW: ';
        break;
    }
    if (this.id > 0 && this.type === 'inbox') {
      this.service.getReplyDetail(this.id, mode).subscribe(
        (object) => {
          this.validateForm.controls.subject.setValue(prefix + object.result.subject);
          this.validateForm.controls.body.setValue(`<div><br/><br/><br/><br/><br/><br/></div><hr/><div class="reply-quote">${object.result.bodyReply}</div>`);
          this.validateForm.controls.listTo.setValue(object.result.listTo);
          this.validateForm.controls.listCc.setValue(object.result.listCc);
          if (mode === 'forward') {
            this.service.cloneFileToForward(this.id).subscribe(
              (res) => {
                this.fileList = res.result.map(x => ({
                  uid : x.id,
                  name : x.fileName,
                  status : 'done'
                }));
                res.result.forEach(element => {
                  this.lstAttach.push(element.id);
                });
              }
            );
          }
        }
      );
    }else{
      let listToRes = [];
      let listCcRes = [];
      this.filesRes.forEach(element => {
        this.lstAttach.push(element.uid);
      });
      Object.keys(this.data.listTo).forEach(element =>{
        listToRes.push(parseInt(element));
      });
      Object.keys(this.data.listCc).forEach(element =>{
        listCcRes.push(parseInt(element));
      });
      this.validateForm.controls.subject.setValue(prefix + this.data.subject);
      this.validateForm.controls.body.setValue(this.data.body);
      this.validateForm.controls.listTo.setValue(listToRes);
      this.validateForm.controls.listCc.setValue(listCcRes);
      this.fileList = this.filesRes;
    }
  }
  openSelectListTo(){
      const dialogRef = this.modalService.create({
      nzTitle: 'Chọn nhân sự',
      nzContent: SelectTreeComponent,
      nzStyle: { top: '20px' },
      nzMaskClosable: false,
      nzComponentParams: {
        value: this.validateForm.controls.listTo.value,
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1000
    });
    dialogRef.afterClose.subscribe((result) => {
      if(result) {
        this.validateForm.controls.listTo.setValue(result);
      }
    });
  }
  openSelectListCc(){
      const dialogRef = this.modalService.create({
      nzTitle: 'Chọn nhân sự',
      nzContent: SelectTreeComponent,
      nzStyle: { top: '20px' },
      nzMaskClosable: false,
      nzComponentParams: {
        value: this.validateForm.controls.listCc.value,
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1000
    });
    dialogRef.afterClose.subscribe((result) => {
      if(result) {
        if(result) {
          this.validateForm.controls.listCc.setValue(result);
        }
      }
    });
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
}
